import { useEffect, useState } from "react";
import { Crown } from "lucide-react";

import { subscriptionService } from "../../services/subscriptionService";

/**
 * Badge distintivo en el topnav cuando el usuario tiene un plan activo.
 * Muestra el nombre del plan (Starter / Pro / Business / …). Si no hay plan
 * activo, no renderiza nada.
 */
export default function PlanBadge() {
  const [planName, setPlanName] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const [subs, plans] = await Promise.all([
          subscriptionService.getMySubscriptions(),
          subscriptionService.getPlans(),
        ]);
        const active = subs.find((s) => s.status === "active");
        if (!active || cancelled) return;
        const plan = plans.find((p) => p.id === active.planId);
        setPlanName(plan?.name ?? "Plan");
      } catch {
        /* sin plan / error → sin badge */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!planName) return null;

  return (
    <div
      className="titlebar-nodrag flex items-center gap-1.5 rounded-full border border-primary/30 bg-gradient-to-r from-primary/20 to-fuchsia-500/15 px-2.5 py-0.5 text-xs font-medium text-primary shadow-[0_0_12px_-2px] shadow-primary/30"
      title={`Plan ${planName} activo`}
    >
      <Crown className="size-3.5" />
      {planName}
    </div>
  );
}
